// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"545fbb60","505":"326e9504","837":"fee8aac2"}[chunkId] + ".chunk.css";
};